import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardPaymentQueueComponent } from './card-payment-queue.component';
import { SystemIconModule } from '@app/transactions/components/transaction-form/system-icon/system-icon.module';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    declarations: [CardPaymentQueueComponent],
    exports: [CardPaymentQueueComponent],
    imports: [CommonModule, SystemIconModule, MatTooltipModule, MatIconModule]
})
export class CardPaymentQueueModule {}
